import React, { useEffect, useState } from 'react'

import LiveSelect from 'live/components/forms/ui/select'
import { jsonHeaders } from 'live/lib/utils'
import i18n from 'live/services/i18n'

type LinkServiceProviderTabProps = {
    interventionId: string
    sectionId: string
    runId: string
    state: Record<string, unknown>
    onChange: (field: string, value: unknown) => void
}

const BASE_URL = '/services/plugin-wells-vis/settings/image-log-mappings/well/link'

export function saveData(
    interventionId: string,
    section: { id: string },
    runId: string,
    state: Record<string, unknown>
): void {
    fetch(`${BASE_URL}?serviceProvider=${state.serviceProvider}`, {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({
            interventionId,
            sectionId: section.id,
            runId
        })
    })
}

const LinkServiceProviderTab = ({
    state,
    onChange,
    interventionId,
    sectionId,
    runId
}: LinkServiceProviderTabProps): React.ReactElement => {
    const [serviceProviders, setServiceProviders] = useState<string[]>([])
    const current = state.serviceProvider

    useEffect(() => {
        const missingInfo = !interventionId || !sectionId || !runId

        fetch(
            `${BASE_URL}${missingInfo ? '' : `?interventionId=${interventionId}&sectionId=${sectionId}&runId=${runId}`}`
        )
            .then(r => r.json())
            .then(serviceProviders => {
                setServiceProviders(serviceProviders.options)
                if (serviceProviders.current) {
                    onChange('serviceProvider', serviceProviders.current)
                }
            })
    }, [interventionId, onChange, runId, sectionId])

    return (
        <div style={{ maxWidth: '300px' }}>
            <LiveSelect
                options={serviceProviders.map(option => ({ label: option, value: option }))}
                label={i18n('Service provider for this process')}
                value={current}
                onChange={value => onChange('serviceProvider', value)}
                clearable={false}
            />
        </div>
    )
}

export default LinkServiceProviderTab
